export default __webpack_public_path__ + "static/media/regular.4b9f72ad.woff2";